import type { LucideProps } from "lucide-react";
import type { ElementType, Ref } from "react";
import { createElement } from "react";

import colors from "theme/colors";

import type { SizeType } from "./constants";
import { DEFAULT_SIZE, SIZES_MAP } from "./constants";

type Props = {
  glyph: ElementType<LucideProps>;
  size?: SizeType;
  color?: string;
  ref?: Ref<SVGSVGElement>;
} & Omit<LucideProps, "size">;

/** @deprecated In favor of LucideProvider. */
const LucideIcon = ({
  glyph,
  color = colors.midGrey,
  size = DEFAULT_SIZE,
  ref,
  ...rest
}: Props) =>
  createElement(glyph, {
    ref,
    width: SIZES_MAP[size],
    height: SIZES_MAP[size],
    color,
    ...rest
  });

export default LucideIcon;
